export type DeviceMode = 'desktop' | 'tablet';

export interface DeviceEnvironment {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
}

export interface DeviceModeResolutionInput {
  environment: DeviceEnvironment;
  search?: string;
}

export const classifyDeviceMode = (environment: DeviceEnvironment): DeviceMode => {
  const { userAgent, platform, maxTouchPoints } = environment;

  if (/\b(?:iPhone|iPod)\b/i.test(userAgent)) return 'desktop';
  if (/\biPad\b/i.test(userAgent)) return 'tablet';

  if (platform === 'MacIntel' && maxTouchPoints > 1) return 'tablet';

  if (!/\bAndroid\b/i.test(userAgent) || /\bMobi(?:le)?\b/i.test(userAgent)) {
    return 'desktop';
  }

  return 'tablet';
};

export const resolveDeviceMode = ({
  environment,
  search = '',
}: DeviceModeResolutionInput): DeviceMode => {
  const override = new URLSearchParams(search).get('deviceMode');
  if (override === 'desktop' || override === 'tablet') return override;

  return classifyDeviceMode(environment);
};
